import { render, staticRenderFns } from "./listprovider.vue?vue&type=template&id=3d7c899b&"
import script from "./listprovider.vue?vue&type=script&lang=js&"
export * from "./listprovider.vue?vue&type=script&lang=js&"
import style0 from "./listprovider.vue?vue&type=style&index=0&id=3d7c899b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports